<app-navigation>
    <app-wachbuch-table *ngIf="showTableStatus"  (editEntry)="editEntry($event)"></app-wachbuch-table> 
    <app-wachbuch-form *ngIf="showFormStatus" (showTable)="showTable()" [entryId]="formEntryId"></app-wachbuch-form>   
</app-navigation>